export let CHANNEL_TYPES = /*#__PURE__*/function (CHANNEL_TYPES) {
  CHANNEL_TYPES["CHANNEL"] = "channel";
  CHANNEL_TYPES["YOUTUBE_FEED"] = "youtube-feed";
  return CHANNEL_TYPES;
}({});
//# sourceMappingURL=channel-types.js.map